import axios, { AxiosRequestConfig } from "axios";
import { LegalEntityDTO, UserDTO } from "@/model/data.model";
import { LegalEntityDef, UserDef } from "@/model/component.model";
import { extractContact } from "./Helpers";
import store from "../vuex/store";

export class UserService {
  getUserByUsername(username: string) {
    return axios
      .get(store.getters.BASE_API_URL + "/auth-registry/users", {
        params: {
          username: username
        }
      })
      .then(function(res) {
        const userDTO = res.data as UserDTO;
        let firstname = "";
        let lastname = "";
        let address = "";
        let city = "";
        let zipCode = "";
        let telephone = "";

        if (userDTO.contact) {
          firstname = userDTO.contact.firstname;
          lastname = userDTO.contact.lastname;
        }
        // todo address store
        if (userDTO.contact.addresses) {
          address = userDTO.contact.addresses[0].address;
          city = userDTO.contact.addresses[0].city;
          zipCode = userDTO.contact.addresses[0].zipCode;
        }
        if (userDTO.contact.contactsReference) {
          const contactTelephone = extractContact(
            userDTO.contact.contactsReference,
            "TELEPHONE"
          );
          telephone = contactTelephone.value;
        }
        const user = {
          id: userDTO.id,
          firstname: firstname,
          lastname: lastname,
          username: userDTO.username,
          address: address,
          city: city,
          zipCode: zipCode,
          telephone: telephone
        } as UserDef;

        return user;
      });
  }

  // https://api.dev.mbehub.cloud.mbeglobal.io/auth-registry/roles/
  getRoleByUsername(username: string) {
    return axios
      .get(store.getters.BASE_API_URL + "/auth-registry/roles", {
        params: {
          username: username
        }
      })
      .then(function(res) {
        return res;
      });
  }

  async loadEntityUsers(idEntity: number, entityType: string) {
    const response = await axios.request({
      url: `${store.getters.BASE_API_URL}/auth-registry/legal-entities/${idEntity}/users`,
      params: { legalEntityType: entityType }
    });
    return response.data;
  }

  searchUsers(request: any, pageRequest: any): Promise<any> {
    const requestConfig: AxiosRequestConfig = {
      url: store.getters.BASE_API_URL + "/auth-registry/users/search",
      method: "POST",
      data: request,
      params: {
        page: pageRequest.number,
        size: pageRequest.size,
        sort: pageRequest.sort
      }
    };
    return axios
      .request(requestConfig)
      .then((res: any) => {
        return res.data;
      })
      .catch(err => {
        console.error(err);
        return Promise.reject(err);
      });
  }
}
